var Vendd = (function (Vendd) {
	'use strict';

	var modelPending = false;
	var popupModelPending = false;

	Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetModel, Vendd.WarehouseSelector, function (envelope) {
		if (modelPending) {
			return false;
		}

		var options = {
			url: 'api/WarehouseSelector/GetModel',
			data: envelope.message.data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
			modelPending = false;
			Vendd.MessageBus.publishAsync(Vendd.WarehouseSelector, new Vendd.WarehouseSelector.Messages.GetModelSuccess(response));
		}

		function onFailure(response) {
			modelPending = false;
			Vendd.MessageBus.publishAsync(Vendd.WarehouseSelector, new Vendd.WarehouseSelector.Messages.GetModelFailed(response));
		}

		modelPending = true;

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetPopupModel, Vendd.WarehouseSelector, function (envelope) {
		if (popupModelPending) {
			return false;
		}

		var options = {
			url: 'api/WarehouseSelectorPopup/GetModel',
			data: envelope.message.data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
			popupModelPending = false;
			Vendd.MessageBus.publishAsync(Vendd.WarehouseSelector, new Vendd.WarehouseSelector.Messages.GetPopupModelSuccess(response));
		}

		function onFailure(response) {
			popupModelPending = false;
			Vendd.MessageBus.publishAsync(Vendd.WarehouseSelector, new Vendd.WarehouseSelector.Messages.GetPopupModelFailed(response));
		}

		popupModelPending = true;

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetGeoAreas, Vendd.WarehouseSelector, function (envelope) {
		var options = {
			url: 'api/WarehouseSelectorPopup/GetGeoAreas',
			data: envelope.message.data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.WarehouseSelector, new Vendd.WarehouseSelector.Messages.GetGeoAreasSuccess(response));
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.WarehouseSelector, new Vendd.WarehouseSelector.Messages.GetGeoAreasFailed(response));
		}

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetStoresByPostCode, Vendd.WarehouseSelector, function (envelope) {
		getStores('api/WarehouseSelectorPopup/GetStoresByPostalCode', envelope.message.data);
	});
	Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetStoresByGeoArea, Vendd.WarehouseSelector, function (envelope) {
		getStores('api/WarehouseSelectorPopup/GetStoresByGeoArea', envelope.message.data);
	});
	Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetStoresByLocation, Vendd.WarehouseSelector, function (envelope) {
		getStores('api/WarehouseSelectorPopup/GetStoresByLocation', envelope.message.data);
	});

	function getStores(url, data) {
		var options = {
			url: url,
			data: data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.WarehouseSelector, new Vendd.WarehouseSelector.Messages.GetStoresSuccess(response));
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.WarehouseSelector, new Vendd.WarehouseSelector.Messages.GetStoresFailed(response));
		}

		Vendd.Service.call(options);
	}

	Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.SetDeliveryShippingMethod, Vendd.WarehouseSelector, function (envelope) {
		setShippingMethod('api/WarehouseSelectorPopup/SetDeliveryShippingMethod', envelope.message.data);
	});
	Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.SetFromStoreShippingMethod, Vendd.WarehouseSelector, function (envelope) {
		setShippingMethod('api/WarehouseSelectorPopup/SetFromStoreShippingMethod', envelope.message.data);
	});

	function setShippingMethod(url, data) {
		var options = {
			url: url,
			data: data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.WarehouseSelector, new Vendd.WarehouseSelector.Messages.SetShippingMethodSuccess(response));
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.WarehouseSelector, new Vendd.WarehouseSelector.Messages.SetShippingMethodFailed(response));
		}

		Vendd.Service.call(options);
	}

	return Vendd;

})(Vendd || {});
